import React, { useState } from "react";
import AddCategoryModal from "./AddCategoryModal";
import { Pencil } from "lucide-react";

const CategoriesSidebar = ({
  categories,
  activeCategory,
  setActiveCategory,
  onCategoryCreated, // optional: parent callback
  onCategoryUpdated, // optional: parent callback
  operatorId,
}) => {
  const [openAdd, setOpenAdd] = useState(false);
  const [editCat, setEditCat] = useState(null);

  return (
    <aside className="hidden md:block w-64 bg-dry text-text rounded-lg p-4">
      <h3 className="text-sm font-semibold mb-4 text-white">
        Categories ({categories.length})
      </h3>

      <ul className="space-y-2 max-h-[50vh] overflow-y-auto scrollbar-thin border border-border rounded-lg">
        {categories.map((cat) => (
          <li
            key={cat._id || cat.name}
            className={`flex items-center justify-between px-3 py-2 rounded-md text-sm cursor-pointer ${
              activeCategory === cat.name
                ? `bg-drylight font-medium`
                : "hover:bg-gray-100 "
            }`}
            style={
              activeCategory === cat.name
                ? { color: cat.color } // use backend color
                : {}
            }
            onMouseEnter={(e) => {
              if (activeCategory !== cat.name) {
                e.currentTarget.style.backgroundColor = "#334155"; // hover color
                e.currentTarget.style.color = cat.color; // optional text contrast
              }
            }}
            onMouseLeave={(e) => {
              if (activeCategory !== cat.name) {
                e.currentTarget.style.backgroundColor = "transparent"; // reset
                e.currentTarget.style.color = ""; // reset text
              }
            }}
            onClick={() => setActiveCategory(cat.name)}
            // onClick={() => setActiveCategoryId(cat._id)}
          >
            <span>{cat.name}</span>
            <div className="flex items-center gap-2">
              <span className="text-xs text-textGray">{cat.count ?? 0}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation(); // prevent selecting category
                  setEditCat(cat);
                  setOpenAdd(true);
                }}
                className="text-xs text-blue-500 hover:underline"
              >
                <Pencil size={12} className="text-textGray" />
              </button>
            </div>
          </li>
        ))}
      </ul>

      <button
        className="mt-4 text-sm text-redlight hover:underline"
        onClick={() => {
          setEditCat(null);
          setOpenAdd(true);
        }}
      >
        + Add category
      </button>

      <AddCategoryModal
        open={openAdd}
        category={editCat} // null = Add, object = Edit
        onClose={() => {
          setOpenAdd(false);
          setEditCat(null);
        }}
        onCreated={(newCat) => {
          onCategoryCreated?.(newCat);
        }}
        onUpdated={(updated) => {
          onCategoryUpdated?.(updated);
        }}
        operatorId={operatorId}
      />
    </aside>
  );
};

export default CategoriesSidebar;
